import { useTranslation } from 'react-i18next';

export const keyPrefix = 'confirmUserBlock';
export const useConfirmUserBlockTranslation = () => useTranslation('entities', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Заблокировать пользователя',
    subtitle: 'Вы уверены, что хотите заблокировать пользователя {{name}}?',
    confirm_button: 'Заблокировать',
    reject_button: 'Отмена',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Block User',
    subtitle: 'Are you sure you want to block user {{name}}?',
    confirm_button: 'Block',
    reject_button: 'Cancel',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Bloquear Usuário',
    subtitle: 'Tem certeza de que deseja bloquear o usuário {{name}}?',
    confirm_button: 'Bloquear',
    reject_button: 'Cancelar',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Bloquear Usuario',
    subtitle: '¿Está seguro de que desea bloquear al usuario {{name}}?',
    confirm_button: 'Bloquear',
    reject_button: 'Cancelar',
  },
}) : {}) as Record<string, unknown>;
